import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import "../styles/GlobalStyles.css";

const UNIVERSITY_OPTIONS = [
    "DEGREE",
    "MEDICAL",
    "PHD",
    "PROFESSIONAL",
    "TECHNICAL"
];

// Enum from backend
const QUALIFICATION_OPTIONS = [
    'Bachelor of Commerce (B Com)',
    'Bachelor of Science (B Sc)',
    'Bachelor of Arts (BA)',
    'Bachelor of Music (BACHELOR OF MUSIC)',
    'Bachelor of Business Administration (BBA)',
    'Bachelor of Business Studies (BBS)',
    'Bachelor of Computer Application (BCA)',
    'Bachelor of Fine Arts (BFA)',
    'Bachelor of Fisheries Science (BFSc)',
    'Bachelor of Social Work (BSW)',
    'Integrated Bachelor of Science (INTEGRATED B Sc)',
    'Integrated Bachelor of Arts (INTEGRATED BA)',
    'Master of Commerce (M Com)',
    'Master of Science (M Sc)',
    'Master of Arts (MA)',
    'Master of Social Work (MSW)',
    'Ayurveda Postgraduate (Ayurveda PG)',
    'Bachelor of Physiotherapy (Bachelor of Physio Therapy)',
    'Bachelor of Ayurvedic Medical Sciences (BAMS)',
    'Bachelor of Dental Surgery (BDS)',
    'Bachelor of Homeopathy Medicine & Surgery (BHMS)',
    'Bachelor of Lab Technology (BLT)',
    'Bachelor of Naturopathy and Yogic Science (BNYS)',
    'Bachelor of Physiotherapy (BPT)',
    'Bachelor of Unani Medicine & Surgery (BUMS)',
    'Diploma in Anaesthetics (DA)',
    'Diploma in Forensic Medicine (DFM)',
    'Doctor of Medicine (DM)',
    'Diploma in Ophthalmic Medicine and Surgery (DOMS)',
    'Master of Public Health',
    'Bachelor of Medicine and Bachelor of Surgery (MBBS)',
    'Doctor of Medicine (MD)',
    'Master of Dental Surgery (MDS)',
    'Master of Health Administration (MHA)',
    'Master of Physiotherapy (MPT)',
    'Master of Surgery (MS Medical)',
    'Master of Veterinary Science (MVSC)',
    'Doctor of Pharmacy Post Baccalaureate (Pharm D Post baccalaureate)',
    'Doctor of Pharmacy (Pharma D)',
    'Doctor of Philosophy (PHD)',
    'Advanced Diploma Courses',
    'Allied Health Science',
    'Auxiliary Nurse Midwifery (ANM)',
    'Bachelor of Commerce & Law (B Com LLB)',
    'Bachelor of Design (B Desgn)',
    'Bachelor of Education (B Ed)',
    'Bachelor of Physical Education (B PEd)',
    'Bachelor of Pharmacy (B Pharma)',
    'Bachelor of Planning (B Plan)',
    'Bachelor of Science Nursing (B Sc Nursing)',
    'Bachelor of Vocational Studies (B Voc)',
    'Bachelor of Arts & Law (BA LLB)',
    'Bachelor of Business Administration & Law (BBA LLB)',
    'BBT',
    'Bachelor of Communication & Journalism (BCJ)',
    'Bachelor of Hospital Administration (BHA)',
    'Bachelor of Hotel Management (BHM)',
    'Bachelor of Library Science (BLS)',
    'Bachelor of Nursing (BNg)',
    'Bachelor of Performing Arts (BPA)',
    'Bachelor of Public Health (BPH)',
    'BSc Ed',
    'Bachelor of Tourism Administration (BTA)',
    'Bachelor of Tourism & Hospitality (BTH)',
    'Bachelor of Travel & Tourism Management (BTTM)',
    'Bachelor of Visual Arts (BVA)',
    'BVOC',
    'Bachelor of Veterinary Science (BVSC)',
    'Bachelor of Veterinary Science & Animal Husbandry (BVSc and AH)',
    'CANS',
    'Cardiology Technician (CARDIOLOGY TECHNICIAN)',
    'CAT',
    'CCARDIO',
    'CCTC',
    'CECG',
    'CEPT',
    'CHI',
    'CHT',
    'CLT',
    'CMLT',
    'CMXT',
    'COT',
    'COTT',
    'CRA',
    'CRI',
    'CRUST',
    'CTT',
    'Diploma in Education (D Ed)',
    'Diploma in Pharmacy (D Pharma)',
    'DAM',
    'DANS',
    'DBBT',
    'DCARDIO',
    'DCBR',
    'DCRE',
    'DDHY',
    'DDIALY',
    'DDRA',
    'DDTH',
    'DEAIE',
    'DECG',
    'DECSE(MR)',
    'Dental Hygienist (DENTAL HYGENIST)',
    'DEPT',
    'DFEM',
    'DHA',
    'DHFSM',
    'DHI',
    'DHLS',
    'DHLST',
    'DHMCT',
    'Diploma Courses',
    'DMIT',
    'DMLT',
    'DMRD',
    'DMRT',
    'DMST',
    'DMSY',
    'DMXT',
    'DO',
    'DOA',
    'DOM',
    'DOT',
    'DOTT',
    'DPM',
    'DPMT',
    'DPT',
    'DREST',
    'DRGA',
    'DRTT',
    'DRUST',
    'DSE',
    'DSME',
    'DSWMECH',
    'DTCD',
    'DTE',
    'DTT',
    'DVR',
    'FWT',
    'General Nursing and Midwifery (GNM)',
    'IMA',
    'IMSC',
    'Integrated Master of Business Administration (Integrated MBA)',
    'Industrial Training Institute Courses (ITI Courses)',
    'Bachelor of Law (LLB)',
    'Master of Laws (LLM)',
    'Master of Design (M Desgn)',
    'Master of Education (M Ed)',
    'Master of Physical Education (M PED)',
    'Master of Pharmacy (M Pharma)',
    'Master of Philosophy (M Phil)',
    'Master of Science Nursing (M Sc Nursing)',
    'Master in Marketing',
    'Master of International Business',
    'Master of Business Administration (MBA)',
    'Master of Business Economics (MBE)',
    'Master of Business Studies (MBS)',
    'Master of Computer Application (MCA)',
    'Master of Communication Journalism (MCJ)',
    'Master of Finance and Accounting (MFA)',
    'Master of Fashion Management (MFM)',
    'Master of Hotel Management (MHM)',
    'Master of Hospital Management (MHM)',
    'MHRD',
    'Medical Imaging Technology (MIT)',
    'Medical Lab Technology (MLT)',
    'Master of Management Studies (MMS)',
    'Master of Performing Arts (MPA)',
    'Master of Public Health (MPH)',
    'MPHA',
    'MPHW',
    'Multi Purpose Veterinary Assistant (MPVA)',
    'MRM',
    'MRMLV',
    'Master of Science Professional (MS Professional)',
    'Master of Tourism Administration (MTA)',
    'Nursery Training (NST)',
    'PBBSC (NURSING)',
    'PMOA',
    'Post Graduation Diploma Courses',
    'SDEBM',
    'SDECN',
    'SDECP',
    'SDEES',
    'SDEIE',
    'SDETV',
    'UGDPET',
    'Aircraft Maintenance Engineering',
    'Bachelor of Architecture (B Arch)',
    'Bachelor of Technology (B Tech)',
    'Bachelor of Engineering (BE)',
    'Bachelor of Fashion Technology (BFT)',
    'Integrated Engineering Bachelor of Technology (INTEGRATED ENGINEERING B TECH)',
    'Master of Architecture (M Arch)',
    'Master of Technology (M Tech)',
    'Master of Engineering (ME)',
    'Master of Fashion Technology (MFT)',
    'Master of Science Technical (MS Technical)',
    'MSIT'
];

const QualificationsSection = ({ onClose, initialData }) => {
    const [qualification, setQualification] = useState("");
    const [qualSearch, setQualSearch] = useState("");
    const [customQualification, setCustomQualification] = useState("");
    const [showQualDropdown, setShowQualDropdown] = useState(false);
    const qualDropdownRef = useRef(null);
    const [university, setUniversity] = useState("");
    const [certificate, setCertificate] = useState(null);
    const [existingCertificate, setExistingCertificate] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        if (initialData) {
            const qual = initialData.qualification || "";
            if (qual && !QUALIFICATION_OPTIONS.includes(qual) && qual !== "Others") {
                setQualification("Others");
                setQualSearch("Others");
                setCustomQualification(qual);
            } else {
                setQualification(qual);
                setQualSearch(qual);
            }
            setUniversity(initialData.university || "");
            setExistingCertificate(initialData.qualification_cert || null);
            setLoading(false);
        } else {
            fetchProfile();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [initialData]);

    const fetchProfile = async () => {
        try {
            const token = localStorage.getItem("token");
            const res = await axios.get(
                `${process.env.REACT_APP_API_URL}/api/profile/getCandprofile`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            // Handle single object structure
            const qualData = res.data.candidate.qualification || {};
            const qual = qualData.qualification || "";
            if (qual && !QUALIFICATION_OPTIONS.includes(qual) && qual !== "Others") {
                setQualification("Others");
                setQualSearch("Others");
                setCustomQualification(qual);
            } else {
                setQualification(qual);
                setQualSearch(qual);
            }
            setUniversity(qualData.university || "");
            setExistingCertificate(qualData.qualification_cert || null);

            setLoading(false);
        } catch (err) {
            console.error(err);
            setLoading(false);
        }
    };

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (qualDropdownRef.current && !qualDropdownRef.current.contains(event.target)) {
                setShowQualDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => document.removeEventListener("mousedown", handleClickOutside);
    }, []);

    const filteredQualifications = [
        ...QUALIFICATION_OPTIONS.filter(opt =>
            opt.toLowerCase().includes(qualSearch.toLowerCase())
        ),
        "Others"
    ];

    const handleSave = async () => {

        const finalQualification = qualification === "Others" ? customQualification : qualification;

        // Validation
        if (!finalQualification || !university) {
            alert("Please select qualification and university");
            return;
        }

        if (!certificate && !existingCertificate) {
            alert("Please upload a certificate (image or PDF)");
            return;
        }


        try {
            const token = localStorage.getItem("token");

            const formData = new FormData();

            formData.append("qualification", finalQualification);
            formData.append("university", university);

            if (certificate) {
                formData.append("qualification_cert", certificate);
            }

            await axios.put(
                `${process.env.REACT_APP_API_URL}/api/profile/update/qualification`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            alert("Qualification details saved successfully.");
            onClose();
            window.location.reload();

        } catch (err) {
            console.error("Error inside handleSave:", err);
            if (err.response) {
                console.error("Server Response Error:", err.response.data);
            }
            alert("Failed to save qualification details");
        }
    };

    const handleDeleteCert = async () => {
        if (!window.confirm("Are you sure you want to permanently delete this certificate?")) {
            return;
        }

        try {
            const token = localStorage.getItem("token");
            const formData = new FormData();
            formData.append("delete_cert", "true");

            await axios.put(
                `${process.env.REACT_APP_API_URL}/api/profile/update/qualification`,
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        "Content-Type": "multipart/form-data"
                    }
                }
            );

            setExistingCertificate(null);
            alert("Certificate deleted successfully.");
        } catch (err) {
            console.error("Error deleting certificate:", err);
            alert("Failed to delete certificate.");
        }
    };

    if (loading) return <div>Loading...</div>;

    return (
        <div className="skills-list" style={{ background: '#fff' }}>
            <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
                <h3>Professional Qualifications</h3>

            </div>

            <div className="form-group" ref={qualDropdownRef} style={{ position: 'relative' }}>
                <label className="profile-label">Qualification</label>
                <input
                    type="text"
                    className="profile-input"
                    placeholder="Search Qualification..."
                    value={qualSearch}
                    onChange={(e) => {
                        setQualSearch(e.target.value);
                        setQualification("");
                        setShowQualDropdown(true);
                    }}
                    onFocus={() => setShowQualDropdown(true)}
                />
                {showQualDropdown && (
                    <ul style={{
                        position: 'absolute',
                        top: '100%',
                        left: 0,
                        right: 0,
                        maxHeight: '200px',
                        overflowY: 'auto',
                        background: '#fff',
                        border: '1px solid #ccc',
                        borderRadius: '4px',
                        zIndex: 1000,
                        margin: 0,
                        padding: 0,
                        listStyle: 'none'
                    }}>
                        {filteredQualifications.length > 0 ? (
                            filteredQualifications.map(opt => (
                                <li
                                    key={opt}
                                    style={{ padding: '8px 12px', cursor: 'pointer', borderBottom: '1px solid #eee' }}
                                    onMouseDown={(e) => e.preventDefault()}
                                    onClick={() => {
                                        setQualification(opt);
                                        setQualSearch(opt);
                                        setShowQualDropdown(false);
                                    }}
                                    onMouseEnter={(e) => e.target.style.backgroundColor = '#f0f0f0'}
                                    onMouseLeave={(e) => e.target.style.backgroundColor = '#fff'}
                                >
                                    {opt}
                                </li>
                            ))
                        ) : (
                            <li style={{ padding: '8px 12px', color: '#999' }}>No options found</li>
                        )}
                    </ul>
                )}

                {qualification === "Others" && (
                    <input
                        type="text"
                        className="profile-input"
                        placeholder="Enter your qualification..."
                        style={{ marginTop: '10px' }}
                        value={customQualification}
                        onChange={(e) => setCustomQualification(e.target.value)}
                    />
                )}
            </div>

            <div className="form-group">
                <label className="profile-label">University Name</label>
                <select
                    className="profile-input"
                    value={university}
                    onChange={(e) => setUniversity(e.target.value)}
                >
                    <option value="">Select University...</option>
                    {UNIVERSITY_OPTIONS.map((uni) => (
                        <option key={uni} value={uni}>
                            {uni}
                        </option>
                    ))}
                </select>
            </div>

            <div className="form-group">
                <label className="profile-label">Upload Certificate (Image or PDF)</label>

                {/* Existing Certificate Display */}
                {existingCertificate && (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px', marginBottom: '10px', padding: '10px', background: '#f8f9fa', borderRadius: '6px' }}>
                        <a
                            href={`${process.env.REACT_APP_API_URL}/${existingCertificate}`}
                            target="_blank"
                            rel="noopener noreferrer"
                            style={{ color: '#007bff', textDecoration: 'none', fontSize: '14px', flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
                        >
                            View Certificate
                        </a>
                        <button
                            type="button"
                            onClick={handleDeleteCert}
                            className="danger-btn"
                            style={{ display: 'flex', alignItems: 'center', gap: '6px' }}
                            title="Delete Certificate"
                        >
                            Delete
                        </button>
                    </div>
                )}

                {!existingCertificate && (
                    <>
                        <input
                            type="file"
                            className="profile-input"
                            accept="image/*,application/pdf"
                            onChange={(e) => setCertificate(e.target.files[0])}
                        />
                        {certificate && (
                            <p className="file-name">Selected: {certificate.name}</p>
                        )}
                    </>
                )}
            </div>

            <div className="button-row">
                <button className="secondary-btn" onClick={onClose}>Cancel</button>
                <button className="primary-btn" onClick={handleSave}>Save Changes</button>
            </div>
        </div>
    );
};

export default QualificationsSection;
